import React from 'react';
import { Card, Typography } from 'antd';

const { Text } = Typography;

const StatsCard = ({ title, value, icon, color = '#1a56db', trend, subtitle, onClick }) => {
  return (
    <Card
      style={{
        borderRadius: 12,
        padding: 20,
        border: '1px solid #e2e8f0',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease'
      }}
      bodyStyle={{ padding: 0 }}
      onClick={onClick}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.1)';
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = 'none';
        }
      }}
    >
      <div style={{
        width: 44,
        height: 44,
        borderRadius: '50%',
        background: `${color}20`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 20,
        color: color
      }}>
        {icon}
      </div>

      <div style={{ fontSize: 28, fontWeight: 700, color: '#0f172a', marginTop: 12 }}>
        {value}
      </div>

      <Text style={{ fontSize: 13, color: '#64748b', display: 'block', marginTop: 4 }}>
        {title}
      </Text>

      {trend && (
        <Text style={{
          fontSize: 13,
          color: trend.startsWith('+') ? '#0e9f6e' : trend.startsWith('-') ? '#f05252' : '#64748b',
          display: 'block',
          marginTop: 4
        }}>
          {trend}
        </Text>
      )}

      {subtitle && (
        <Text style={{ fontSize: 12, color: '#94a3b8', display: 'block', marginTop: 4 }}>
          {subtitle}
        </Text>
      )}
    </Card>
  );
};

export default StatsCard;
